export function path(root, sublink) {
  return `${root}${sublink}`;
}

const ROOTS_AUTH = "/auth";
const ROOTS_DASHBOARD = "/admin";
const ROOTS_USER = "/user";

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, "/login"),
  register: path(ROOTS_AUTH, "/register"),
  loginUnprotected: path(ROOTS_AUTH, "/login-unprotected"),
  coinpayment: path(ROOTS_AUTH, "/coin-payment"),
  registerUnprotected: path(ROOTS_AUTH, "/register-unprotected"),
  verify: path(ROOTS_AUTH, "/verify"),
  resetPassword: path(ROOTS_AUTH, "/reset-password"),
  resetAccountId: path(ROOTS_AUTH, "/reset-accountId"),
  resendVerifyAccount: path(ROOTS_AUTH, "/resend-verifyaccount"),
  newpassword: path(ROOTS_AUTH, "/new-password"),
  emailmessage: path(ROOTS_AUTH, "/emailmessage"),
  // view: (data) => path(ROOTS_DASHBOARD, `/register/${data}`),
};

export const PATH_PAGE = {
  comingSoon: "/coming-soon",
  maintenance: "/maintenance",
  pricing: "/pricing",
  payment: "/payment",
  about: "/about-us",
  contact: "/contact-us",
  page404: "/404",
  page500: "/500",
  components: "/components",
  exchanges: "/exchange-rate",
};

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  activeSubscriptions: {
    root: path(ROOTS_DASHBOARD, "/subscriptions/user"),
  },
  statistics: {
    root: path(ROOTS_DASHBOARD, "/statistics"),
    subscriptions_users: path(
      ROOTS_DASHBOARD,
      "/statistics/subscriptions_users"
    ),
    profile_user: path(ROOTS_DASHBOARD, "/statistics/profile_user"),
  },
  directors: {
    root: path(ROOTS_DASHBOARD, "/directors"),
  },

  general: {
    app: path(ROOTS_DASHBOARD, "/dashboard"),
    ecommerce: path(ROOTS_DASHBOARD, "/ecommerce"),
    analytics: path(ROOTS_DASHBOARD, "/analytics"),
    banking: path(ROOTS_DASHBOARD, "/banking"),
    booking: path(ROOTS_DASHBOARD, "/booking"),
    home: path(ROOTS_DASHBOARD, "/home"),
    test: path(ROOTS_DASHBOARD, "/test"),
  },
  mail: {
    root: path(ROOTS_DASHBOARD, "/communication/mails"),
    all: path(ROOTS_DASHBOARD, "/communication/mails/all"),
  },

  coupon_report: {
    root: path(ROOTS_DASHBOARD, "/coupon_report"),
  },
  chat: {
    root: path(ROOTS_DASHBOARD, "/chat"),
    new: path(ROOTS_DASHBOARD, "/chat/new"),
    view: (name) => path(ROOTS_DASHBOARD, `/chat/${name}`),
  },
  calendar: path(ROOTS_DASHBOARD, "/calendar"),
  kanban: path(ROOTS_DASHBOARD, "/kanban"),
  user: {
    root: path(ROOTS_DASHBOARD, "/user"),
    new: path(ROOTS_DASHBOARD, "/user/new"),
    list: path(ROOTS_DASHBOARD, "/user/list"),
    cards: path(ROOTS_DASHBOARD, "/user/cards"),
    profile: {
      root: path(ROOTS_DASHBOARD, "/profile"),
      settings: path(ROOTS_DASHBOARD, "/profile/settings"),
    },

    account: path(ROOTS_DASHBOARD, "/account"),
    edit: (name) => path(ROOTS_DASHBOARD, `/user/${name}/edit`),
    demoEdit: path(ROOTS_DASHBOARD, `/user/reece-chung/edit`),
  },

  eCommerce: {
    root: path(ROOTS_DASHBOARD, "/e-commerce"),
    shop: path(ROOTS_DASHBOARD, "/e-commerce/shop"),
    list: path(ROOTS_DASHBOARD, "/e-commerce/list"),
    checkout: path(ROOTS_DASHBOARD, "/e-commerce/checkout"),
    new: path(ROOTS_DASHBOARD, "/e-commerce/product/new"),
    view: (name) => path(ROOTS_DASHBOARD, `/e-commerce/product/${name}`),
    edit: (name) => path(ROOTS_DASHBOARD, `/e-commerce/product/${name}/edit`),
    demoEdit: path(
      ROOTS_DASHBOARD,
      "/e-commerce/product/nike-blazer-low-77-vintage/edit"
    ),
    demoView: path(
      ROOTS_DASHBOARD,
      "/e-commerce/product/nike-air-force-1-ndestrukt"
    ),
  },
  invoice: {
    root: path(ROOTS_DASHBOARD, "/invoice"),
    list: path(ROOTS_DASHBOARD, "/invoice/list"),
    new: path(ROOTS_DASHBOARD, "/invoice/new"),
    view: (id) => path(ROOTS_DASHBOARD, `/invoice/${id}`),
    edit: (id) => path(ROOTS_DASHBOARD, `/invoice/${id}/edit`),
    demoEdit: path(
      ROOTS_DASHBOARD,
      "/invoice/e99f09a7-dd88-49d5-b1c8-1daf80c2d7b1/edit"
    ),
    demoView: path(
      ROOTS_DASHBOARD,
      "/invoice/e99f09a7-dd88-49d5-b1c8-1daf80c2d7b5"
    ),
  },

  blog: {
    root: path(ROOTS_DASHBOARD, "/blog"),
    posts: path(ROOTS_DASHBOARD, "/blog/posts"),
    new: path(ROOTS_DASHBOARD, "/blog/new"),
    view: (title) => path(ROOTS_DASHBOARD, `/blog/post/${title}`),
    demoView: path(
      ROOTS_DASHBOARD,
      "/blog/post/apply-these-7-secret-techniques-to-improve-event"
    ),
  },
  genealogy: {
    root: path(ROOTS_DASHBOARD, "/genealogy"),
    binary: path(ROOTS_DASHBOARD, "/genealogy/binary"),
    pool100: path(ROOTS_DASHBOARD, "/genealogy/pool100"),
    pool250: path(ROOTS_DASHBOARD, "/genealogy/pool250"),
    pool500: path(ROOTS_DASHBOARD, "/genealogy/pool500"),
    pool1000: path(ROOTS_DASHBOARD, "/genealogy/pool1000"),

    rebirth100: path(ROOTS_DASHBOARD, "/genealogy/rebirth100"),
    rebirth250: path(ROOTS_DASHBOARD, "/genealogy/rebirth250"),
    rebirth500: path(ROOTS_DASHBOARD, "/genealogy/rebirth500"),
    rebirth1000: path(ROOTS_DASHBOARD, "/genealogy/rebirth1000"),
    sponsor: path(ROOTS_DASHBOARD, "/genealogy/sponsor"),
    tree: path(ROOTS_DASHBOARD, "/genealogy/tree"),
  },
  financial: {
    root: path(ROOTS_DASHBOARD, "/financial"),
    ewallet: path(ROOTS_DASHBOARD, "/financial/e-wallet"),
    exhaust: path(ROOTS_DASHBOARD, "/financial/exhaust"),
    deposit_wallet: path(ROOTS_DASHBOARD, "/financial/deposit-wallet"),
    fund_credits: path(ROOTS_DASHBOARD, "/financial/fund-credits"),
    payout: path(ROOTS_DASHBOARD, "/financial/payout"),
    financial_report: path(ROOTS_DASHBOARD, "/financial/report"),
    // coupon_report: path(ROOTS_DASHBOARD, "/financial/coupon_report"),
    order_approval: path(ROOTS_DASHBOARD, "/financial/order_approval"),
    fund_allocation: path(ROOTS_DASHBOARD, "/financial/fund_allocation"),
  },
  teams: {
    root: path(ROOTS_DASHBOARD, "/teams"),
    team: path(ROOTS_DASHBOARD, "/teams/team"),
    sponsorChange: path(ROOTS_DASHBOARD, "/teams/sponsorChange"),
    giftCoupon: path(ROOTS_DASHBOARD, "/teams/giftCoupon"),
  },
  communication: {
    root: path(ROOTS_DASHBOARD, "/communication"),
    blogCategories: path(ROOTS_DASHBOARD, "/communication/blog/categories"),
    draft_blog: path(ROOTS_DASHBOARD, "/communication/blog/posts/drafts"),
    help_center: path(ROOTS_DASHBOARD, "/communication/help-center"),
    help_center_tickets: path(
      ROOTS_DASHBOARD,
      "/communication/help-center/tickets"
    ),
    viewTickets: (id) =>
      path(ROOTS_DASHBOARD, `/communication/help-center/tickets/view/${id}`),

    newBlog: path(ROOTS_DASHBOARD, "/communication/blog/new"),
    editBlog: (bid) => path(ROOTS_DASHBOARD, `/communication/blog/${bid}`),
    blog: path(ROOTS_DASHBOARD, "/communication/blog/posts/published"),
    com_faqs: path(ROOTS_DASHBOARD, "/communication/faqs"),
    mails: path(ROOTS_DASHBOARD, "/communication/mails/all"),
    com_support_department: path(
      ROOTS_DASHBOARD,
      "/communication/support/department"
    ),
    com_support_categories: path(
      ROOTS_DASHBOARD,
      "/communication/support/categories"
    ),
    com_support_priorities: path(
      ROOTS_DASHBOARD,
      "/communication/support/priorities"
    ),
    com_support_canned_response: path(
      ROOTS_DASHBOARD,
      "/communication/support/canned-response"
    ),
    com_support_tickets: path(
      ROOTS_DASHBOARD,
      "/communication/support/tickets"
    ),
    com_article_categories: path(
      ROOTS_DASHBOARD,
      "/communication/com_article_categories"
    ),
    com_article: path(ROOTS_DASHBOARD, "/communication/articles"),
    article_categories: path(
      ROOTS_DASHBOARD,
      "/communication/articles/categories"
    ),
  },
  tools: {
    root: path(ROOTS_DASHBOARD, "/tools"),
    documents: path(ROOTS_DASHBOARD, "/tools/documents"),
    videos: path(ROOTS_DASHBOARD, "/tools/videos"),
  },
  dashboard: {
    root: path(ROOTS_DASHBOARD, "/dashboard"),
    business: path(ROOTS_DASHBOARD, "/dashboard/business"),
    network: path(ROOTS_DASHBOARD, "/dashboard/network"),
  },
  register: {
    root: path(ROOTS_DASHBOARD, "/register"),
  },
  allocateFund: {
    root: path(ROOTS_DASHBOARD, "/allocateFund"),
  },
  members: {
    root: path(ROOTS_DASHBOARD, "/members"),
    network: path(ROOTS_DASHBOARD, "/members/network"),
    register: path(ROOTS_DASHBOARD, "/members/register"),

    investor: path(ROOTS_DASHBOARD, "/members/customer"),
    advisor: path(ROOTS_DASHBOARD, "/members/advisor"),

    agency: path(ROOTS_DASHBOARD, "/members/agency"),

    senior_agency: path(ROOTS_DASHBOARD, "/members/senior_agency"),
    seniorPartner: path(ROOTS_DASHBOARD, "/members/seniorPartner"),

    executive_partner: path(ROOTS_DASHBOARD, "/members/executive_partner"),

    senior_executive_partner: path(
      ROOTS_DASHBOARD,
      "/members/senior_executive_partner"
    ),

    elite: path(ROOTS_DASHBOARD, "/members/elite"),
    senior_elite: path(ROOTS_DASHBOARD, "/members/senior_elite"),

    sales_manager: path(ROOTS_DASHBOARD, "/members/sales_manager"),
    regional_manager: path(ROOTS_DASHBOARD, "/members/regional_manager"),
    general_manager: path(ROOTS_DASHBOARD, "/members/general_manager"),

    holdingTank: path(ROOTS_DASHBOARD, "/members/holding-tank"),
    member_profile: path(ROOTS_DASHBOARD, "/members/profile"),
  },
  subscriptions: {
    root: path(ROOTS_DASHBOARD, "/subscriptions"),
    add_product: path(ROOTS_DASHBOARD, "/subscriptions/add_product"),
    add_business: path(ROOTS_DASHBOARD, "/subscriptions/add_business"),
  },
  subAdmin: {
    root: path(ROOTS_DASHBOARD, "/sub-admin"),
    sub_admins: path(ROOTS_DASHBOARD, "/sub-admin"),
    sub_admin_user: path(ROOTS_DASHBOARD, "/sub-admin/sub_admin_user"),
    add_sub_admin: path(ROOTS_DASHBOARD, "/sub-admin/add"),
    add_user_group: path(ROOTS_DASHBOARD, "/sub-admin/group/add"),
  },
  holdingTank: {
    root: path(ROOTS_DASHBOARD, "/holding-tank"),
  },
  store: {
    root: path(ROOTS_DASHBOARD, "/store"),
    product_categories: path(ROOTS_DASHBOARD, "/store/products/categories"),
    products: path(ROOTS_DASHBOARD, "/store/products"),
    material_categories: path(ROOTS_DASHBOARD, "/store/materials/categories"),
    material: path(ROOTS_DASHBOARD, "/store/materials"),
    material_add: path(ROOTS_DASHBOARD, "/store/materials/add"),
    material_view: path(ROOTS_DASHBOARD, "/store/materials"),
    events: path(ROOTS_DASHBOARD, "/store/events"),
    events_add: path(ROOTS_DASHBOARD, "/store/events/add"),
    events_edit: path(ROOTS_DASHBOARD, "/store/events"),
    user_reviews: path(ROOTS_DASHBOARD, "/store/reviews"),
    user_reviews_add: path(ROOTS_DASHBOARD, "/store/reviews/add"),
    user_reviews_edit: path(ROOTS_DASHBOARD, "/store/reviews"),
    assign_subscriptions_cat: path(
      ROOTS_DASHBOARD,
      "/store/assign_subscriptions_cat"
    ),
    assign_subscriptions_add_product: path(
      ROOTS_DASHBOARD,
      "/store/assign_subscriptions/add_product"
    ),
    assign_subscriptions: path(ROOTS_DASHBOARD, "/store/assign_subscriptions"),
    business_builder_subscriptions: path(
      ROOTS_DASHBOARD,
      "/store/business_builder_subscriptions"
    ),
    sales: path(ROOTS_DASHBOARD, "/store/sales"),
    materials_management: path(ROOTS_DASHBOARD, "/store/materials_management"),
    business_builder: path(ROOTS_DASHBOARD, "/store/business_builder"),
    review_management: path(ROOTS_DASHBOARD, "/store/review_management"),
    user_subscriptions: path(ROOTS_DASHBOARD, "/store/user_subscriptions"),
    telegram_page: path(ROOTS_DASHBOARD, "/store/telegram_page"),
    coupons: path(ROOTS_DASHBOARD, "/store/coupons"),
    coupons_add: path(ROOTS_DASHBOARD, "/store/coupons/add"),
    coupons_edit: path(ROOTS_DASHBOARD, "/store/coupons"),
    product_access: path(ROOTS_DASHBOARD, "/store/product_access"),
    product_questions: path(ROOTS_DASHBOARD, "/store/product_questions"),
    product_edit: path(ROOTS_DASHBOARD, "/store/products"),
    product_add: path(ROOTS_DASHBOARD, "/store/products/add"),
    product_combo: path(ROOTS_DASHBOARD, "/store/products/combo"),
    sample_document: path(ROOTS_DASHBOARD, "/store/sample_document"),
  },
  voucher: {
    root: path(ROOTS_DASHBOARD, "/voucher"),
  },

  settings: {
    root: path(ROOTS_DASHBOARD, "/settings"),
    network: path(ROOTS_DASHBOARD, "/settings/network"),
    brand: path(ROOTS_DASHBOARD, "/settings/brand"),
    business: path(ROOTS_DASHBOARD, "/settings/business"),
    withdrawal: path(ROOTS_DASHBOARD, "/settings/withdrawal"),
    business_builder: path(ROOTS_DASHBOARD, "/settings/business_builder"),
    app_settings: path(ROOTS_DASHBOARD, "/settings/app_settings"),
    email_settings: path(ROOTS_DASHBOARD, "/settings/email_settings"),
    terms_conditions: path(ROOTS_DASHBOARD, "/settings/terms_conditions"),
    user_guidance: path(ROOTS_DASHBOARD, "/settings/user_guidance"),
    get_started: path(ROOTS_DASHBOARD, "/settings/get_started"),
    clip: path(ROOTS_DASHBOARD, "/settings/clip"),
    life: path(ROOTS_DASHBOARD, "/settings/life"),
    sip: path(ROOTS_DASHBOARD, "/settings/sip"),
    idp: path(ROOTS_DASHBOARD, "/settings/idp"),
  },
  report: {
    root: path(ROOTS_DASHBOARD, "/report"),
    builder: path(ROOTS_DASHBOARD, "/report/builder"),
    builder: path(ROOTS_DASHBOARD, "/report/builder"),
    // old
    fund_credit: path(ROOTS_DASHBOARD, "/report/fund/credit"),
    joining: path(ROOTS_DASHBOARD, "/report/joining"),
    member_income: path(ROOTS_DASHBOARD, "/report/income"),
    top_earners: path(ROOTS_DASHBOARD, "/report/earners"),
    payout_report: path(ROOTS_DASHBOARD, "/report/payout"),
    rebirth: path(ROOTS_DASHBOARD, "/report/rebirth"),
    sales_report: path(ROOTS_DASHBOARD, "/report/sales"),
    builder_subscription: path(ROOTS_DASHBOARD, "/report/builder_subscription"),
    point_history: path(ROOTS_DASHBOARD, "/report/point/history"),
    poolReport: path(ROOTS_DASHBOARD, "/report/poolReport"),
    profilereport: path(ROOTS_DASHBOARD, "/report/profilereport"),
    director: path(ROOTS_DASHBOARD, "/report/director"),
    referralReport: path(ROOTS_DASHBOARD, "/report/referralReport"),
    stake: path(ROOTS_DASHBOARD, "/report/stake"),

    idp: path(ROOTS_DASHBOARD, "/report/idp"),
    sip: path(ROOTS_DASHBOARD, "/report/sip"),
    lp: path(ROOTS_DASHBOARD, "/report/lp"),
    tab: path(ROOTS_DASHBOARD, "/report/tab"),
    roi_wallet: path(ROOTS_DASHBOARD, "/report/roi-wallet"),
    withdrawal: path(ROOTS_DASHBOARD, "/report/withdrawal"),
    trip: path(ROOTS_DASHBOARD, "/report/trip"),
    reward: path(ROOTS_DASHBOARD, "/report/reward"),

    usersRebirth: path(ROOTS_DASHBOARD, "/report/users-rebirth"),
    salePartner: path(ROOTS_DASHBOARD, "/report/salePartner"),
  },
};

export const PATH_USER = {
  invest: {
    root: path(ROOTS_USER, "/invest"),
    gift: path(ROOTS_USER, "/invest/gift-code"),
    stake: path(ROOTS_USER, "/invest/stake"),
    life: path(ROOTS_USER, "/invest/life"),
    idp: path(ROOTS_USER, "/invest/idp"),
    sip: path(ROOTS_USER, "/invest/sip"),
    view: (id) => path(ROOTS_USER, `/invest/${id}`),
    myOrders: {
      root: path(ROOTS_USER, "/invest/my-orders"),
      view: (id) => path(ROOTS_USER, `/invest/my-orders/${id}`),
    },
    pending_payments: {
      root: path(ROOTS_USER, "/invest/pending_payments"),
    },
  },

  voucher: { root: path(ROOTS_USER, "/voucher") },
  user_dashboard: path(ROOTS_USER, "/dashboard"),
  root: path(ROOTS_USER, "/dashboard"),
  test: path(ROOTS_USER, "/test"),
  events: path(ROOTS_USER, "/events"),
  investor: path(ROOTS_USER, "/investor"),
  reward: path(ROOTS_USER, "/reward"),
  team: path(ROOTS_USER, "/team"),

  profile: { root: path(ROOTS_USER, "/profile") },
  telegram: path(ROOTS_USER, "/telegram"),
  subscriptions: {
    root: path(ROOTS_USER, "/subscriptions"),
    blog: (id) =>
      path(ROOTS_USER, `/subscriptions/blogs?type=subscriptions&id=${id}`),
    view:
      (id) =>
      (subPath = "") =>
        path(ROOTS_USER, `/subscriptions/view/${id}/${subPath}`),
  },
  onlineStore: {
    root: path(ROOTS_USER, "/online-store"),
    productSubscription: {
      root: path(ROOTS_USER, "/online-store/product-subscription"),
      checkout: path(ROOTS_USER, "/online-store/product-subscription/checkout"),

      view: (name) =>
        path(ROOTS_USER, `/online-store/product-subscription/${name}`),
    },
    checkout: path(ROOTS_USER, "/online-store/checkout"),
    poolupgrade: path(ROOTS_USER, "/online-store/poolupgrade"),
  },
  my_orders: {
    root: path(ROOTS_USER, "/online-store/my-orders"),
    view: (id) => path(ROOTS_USER, `/online-store/my-orders/${id}`),
  },

  blogs: {
    root: path(ROOTS_USER, "/blogs"),
    new: path(ROOTS_USER, "/blogs/new"),
    view: (param) => path(ROOTS_USER, `/blogs/${param}`),
  },
  business_builder: {
    root: path(ROOTS_USER, "/business-builder"),
    subscriptions: path(ROOTS_USER, "/business-builder/subscriptions"),
    history: path(ROOTS_USER, "/business-builder/history"),
    materials: {
      root: path(ROOTS_USER, "/business-builder/materials"),
      view: (view = "blog") =>
        path(ROOTS_USER, `/business-builder/materials/${view}`),
    },
  },
  genealogy: {
    root: path(ROOTS_USER, "/genealogy"),
    binary: path(ROOTS_USER, "/genealogy/binary"),
    pool100: path(ROOTS_USER, "/genealogy/pool100"),
    pool250: path(ROOTS_USER, "/genealogy/pool250"),
    pool500: path(ROOTS_USER, "/genealogy/pool500"),
    pool1000: path(ROOTS_USER, "/genealogy/pool1000"),
    sponsor: path(ROOTS_USER, "/genealogy/sponsor"),
    affiliate: path(ROOTS_USER, "/genealogy/affiliate"),
    binaryLeg: path(ROOTS_USER, "/genealogy/binaryLeg"),
  },

  financial: {
    root: path(ROOTS_USER, "/financial"),
    gift: { root: path(ROOTS_USER, "/financial/gift") },
    giftCoupon: path(ROOTS_USER, "/financial/gift-coupon"),

    stakeReport: {
      root: path(ROOTS_USER, "/financial/stake-report"),
    },

    idpReport: {
      root: path(ROOTS_USER, "/financial/idp-report"),
    },

    sipReport: {
      root: path(ROOTS_USER, "/financial/sip-report"),
    },
    lpReport: {
      root: path(ROOTS_USER, "/financial/lp-report"),
    },
    eWallet: path(ROOTS_USER, "/financial/e-wallet"),
    depositWallet: path(ROOTS_USER, "/financial/deposit-wallet"),
    fundsTransfer: path(ROOTS_USER, "/financial/funds-transfer"),
    addFund: path(ROOTS_USER, "/financial/addFund"),
    payout: path(ROOTS_USER, "/financial/payout"),
    coinAddress: path(ROOTS_USER, "/financial/coin-address"),
  },
  helpCenter: {
    root: path(ROOTS_USER, "/help-center"),
    tickets: path(ROOTS_USER, "/help-center/tickets"),
    faq: {
      root: path(ROOTS_USER, "/help-center/faqs"),
      view: (view = "payment") => path(ROOTS_USER, `/help-center/faqs/${view}`),
    },
    knowledgeBase: {
      root: path(ROOTS_USER, `/help-center/knowledge-base`),
      question: (view) =>
        path(ROOTS_USER, `/help-center/knowledge-base/${view}`),
    },
    mails: {
      root: path(ROOTS_USER, "/help-center/mails"),
      all: path(ROOTS_USER, "/help-center/mails/all"),
    },
    view: (label) => path(ROOTS_USER, `/help-center/mails/${label}`),
    createTicket: {
      view: path(ROOTS_USER, "/help-center/create-ticket"),
      subCategory: (category = "all") =>
        path(ROOTS_USER, `/help-center/create-ticket/${category}`),
      contactSupport: path(
        ROOTS_USER,
        "/help-center/create-ticket/contact-support"
      ),
      otherSupport: path(
        ROOTS_USER,
        "/help-center/create-ticket/other-support"
      ),
    },

    mySupportTicket: path(
      ROOTS_USER,
      "/help-center/create-ticket/my-support-ticket"
    ),
  },
  reports: {
    root: path(ROOTS_USER, "/reports"),
    incomeReport: path(ROOTS_USER, "/reports/incomeReport"),
    referralReport: path(ROOTS_USER, "/reports/referralReport"),
    withdrawalReport: path(ROOTS_USER, "/reports/withdrawalReport"),
  },
  missedPoints: {
    root: path(ROOTS_USER, "/missed-points"),
  },
};

export const USER_ROUTES = [
  "/dashboard",
  "/dashboard",
  "/events",
  "/profile",
  "/telegram",
  "/subscriptions",
  "/subscriptions/blogs?type=subscriptions&id=${id}",
  "/subscriptions/view/${id}/${subPath}",
  "/online-store",
  "/online-store/product-subscription",
  "/online-store/product-subscription/checkout",
  "/online-store/product-subscription/${name}",
  "/online-store/my-orders/${id}",
  "/online-store/checkout",
  "/online-store/my-orders",
  "/blogs",
  "/blogs/new",
  "/blogs/${param}",
  "/business-builder",
  "/business-builder/subscriptions",
  "/business-builder/history",
  "/business-builder/materials",
  "/business-builder/materials/${view}",
  "/genealogy",
  "/genealogy/binary",
  "/genealogy/sponsor",
  "/genealogy/affiliate",
  "/genealogy/binaryLeg",
  "/financial",
  "/financial/e-wallet",
  "/financial/deposit-wallet",
  "/financial/funds-transfer",
  "/financial/payout",
  "/financial/coin-address",
  "/help-center",
  "/help-center/tickets",
  "/help-center/faqs",
  "/help-center/mails",
  "/help-center/mails/all",
  "/help-center/create-ticket",
  "/help-center/create-ticket/contact-support",
  "/help-center/create-ticket/other-support",
  "/help-center/create-ticket/my-support-ticket",
  "/help-center/faqs/${view}",
  "/help-center/knowledge-base",
  "/help-center/knowledge-base/${view}",
  "/help-center/mails/${label}",
  "/help-center/create-ticket/${category}",
  "/income-report",
  "/missed-points",
];

export const PATH_DOCS = "";
